import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { useCallback, useRef } from 'react';
import { getEmailContactLoadOptions, getEmailContactValue, getSelectOptionsFromContacts, getToFieldValidationMessage } from '../../utils/email';
import debounce from 'transmute/debounce';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToField = () => {
  const {
    selectedToValue,
    selectedCcValues,
    updateSelectedToValue
  } = useEmailShareTabContext();
  const handleSelectedOptionChange = useCallback(event => {
    const option = event.target.value;
    updateSelectedToValue(option.record);
  }, [updateSelectedToValue]);
  const validationMessage = getToFieldValidationMessage(selectedToValue, selectedCcValues);
  const loadOptions = useRef(debounce(300, getEmailContactLoadOptions())).current;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.toField.label"
    }),
    required: true,
    error: !!validationMessage,
    validationMessage: validationMessage,
    paddingBlockStart: "0",
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "email-share-tab-to-field",
      onSelectedOptionChange: handleSelectedOptionChange,
      loadOptions: loadOptions,
      value: getEmailContactValue(selectedToValue),
      options: getSelectOptionsFromContacts(selectedToValue ? [selectedToValue] : [])
    })
  });
};